import dayjs from "dayjs";

const formatDate = (dateString) => {
	return dayjs(dateString, "YYYY-MM-DD+h:mm").format("YYYY-MM-DD");
};

export default formatDate;
